/**
 * Words for a stamp book given to someone new (2026-10-20) — held until they
 * join, by an invite email or a link the giver sends themselves.
 */

import type { StampGift } from '../letters/api';
import { toiypAddress } from '../onboarding/share';

function dayMonth(iso: string): string {
  return new Date(iso).toLocaleDateString([], { day: 'numeric', month: 'long' });
}

/** Who a held gift is for, as the giver knows them. */
export function heldFor(g: Pick<StampGift, 'invite'>): string {
  return g.invite?.email ?? 'someone new';
}

/** Where a held gift stands. */
export function heldPhrase(g: Pick<StampGift, 'invite'>): string {
  const until = g.invite?.expiresAt ? ` until ${dayMonth(g.invite.expiresAt)}` : '';
  return g.invite?.email ? `waiting for them to join${until}` : `waiting for your link to be opened${until}`;
}

/** The line that carries a gift link — on WhatsApp, the share sheet and the clipboard. */
export function giftShareText(handle: string, collectionName: string, url: string): string {
  return `I've sent you a stamp book on toiyp (${collectionName}) — it's waiting for you, with a note. I'm ${toiypAddress(handle)}. Come and write me a proper letter: ${url}`;
}
